<template>
  <div class="job-list">
    <h3>标准岗位管理</h3>

    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button-group>
          <el-button
            type="primary"
            @click="$router.push('/standardJobDetail/edit')"
            size="mini"
            >新增</el-button
          >
        </el-button-group>
      </el-form-item>
      <el-form-item label="乙方昵称">
        <el-input v-model="filter.nickName" placeholder="乙方昵称"></el-input>
      </el-form-item>
      <el-form-item label="乙方姓名">
        <el-input v-model="filter.realName" placeholder="乙方姓名"></el-input>
      </el-form-item>
      <el-form-item label="乙方ID">
        <el-input v-model="filter.userId" placeholder="乙方ID"></el-input>
      </el-form-item>
      <el-form-item label="岗位名称">
        <el-input v-model="filter.name" placeholder="岗位名称"></el-input>
      </el-form-item>
      <el-form-item label="岗位标题">
        <el-input v-model="filter.title" placeholder="岗位标题"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="fetch(1)" size="mini"
            >查询</el-button
          >
          <el-button @click="reset">重置</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="nickName" label="乙方昵称"></el-table-column>
      <el-table-column prop="realName" label="乙方姓名"> </el-table-column>
      <el-table-column prop="userId" label=" 乙方 ID"> </el-table-column>
      <el-table-column prop="name" label="岗位名称"></el-table-column>
      <el-table-column prop="title" label="岗位标题"></el-table-column>
      <el-table-column prop="monthlyRate" label="岗位月薪"> </el-table-column>
      <el-table-column prop="hourlyRate" label="岗位时薪"> </el-table-column>
      <el-table-column prop="jobCategory" label="岗位一级类目">
        <template slot-scope="scope">
          {{ scope.row.jobCategory.name }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="岗位 ID"></el-table-column>
      <el-table-column prop="createTime" width="150" label="创建时间">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        width="150"
        label="最后修改时间"
      ></el-table-column>
      <el-table-column
        prop="updateOperator"
        label="最后修改人"
      ></el-table-column>
      <el-table-column label="复制链接">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="copy-btn"
            :data-clipboard-text="`${frontUrl}/standardJob/${scope.row.id}`"
            @click="copy"
            >复制链接</el-button
          >
        </template>
      </el-table-column>

      <el-table-column label="操作" flex="right">
        <template slot-scope="scope">
          <el-dropdown size="medium" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-menu" style="font-size: 24px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="{ action: 'switchJob', data: scope.row }"
              >
                <a
                  :href="`${frontUrl}/standardJob/${scope.row.id}`"
                  target="_blank"
                  >查看</a
                >
              </el-dropdown-item>
              <el-dropdown-item command="">
                <a
                  :href="`/standardJobDetail/edit?id=${scope.row.id}`"
                  target="_blank"
                >
                  编辑
                </a>
              </el-dropdown-item>

              <el-dropdown-item :command="{ action: 'del', data: scope.row }">
                删除
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";
import Clipboard from "clipboard";

const { standardJob } = api;

export default {
  name: "job-list",
  data() {
    return {
      map,
      loading: true,
      list: [],
      limit: 20,
      pageNum: 1,
      total: 0,
      filter: {
        userId: null,
        title: null,
        name: null,
        nickName: null,
        realName: null,
      },
    };
  },
  components: {},
  computed: {},
  watch: {
    pageNum() {
      this.fetch(2);
    },
  },
  create() {
    // this.filter.jobId = this.$route.query.jobId;
  },
  methods: {
    reset() {
      this.filter = {
        userId: null,
        title: null,
        name: null,
        nickName: null,
        realName: null,
      };
      this.fetch();
    },
    copy() {
      var clipboard = new Clipboard(".copy-btn");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.error("复制失败，请手动复制收款地址");
        // 释放内存
        clipboard.destroy();
      });
    },
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }

      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;
      let { userId, title, name, nickName, realName } = this.filter;

      let obj = {
        pageNum: pageNum,
        limit: limit,
        userId,
        title,
        name,
        nickName,
        realName,
      };

      let res = await standardJob.list(obj);
      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    handleCommand(command) {
      let action = command.action;
      let data = command.data;
      switch (action) {
        case "del":
          this.delActivity(data);
          break;
        default:
      }
    },
    delActivity(deldata) {
      this.$confirm("删除活动后不可恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "再想想",
        type: "warning",
      })
        .then(async () => {
          if (this.isSubmiting) return false;
          this.isSubmiting = true;
          let {
            data: { code, data },
          } = await standardJob.delete({ id: deldata.id });
          if (code == 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.fetch();
          }
          this.isSubmiting = false;
        })
        .catch((e) => {
          console.log(e);
          this.isSubmiting = false;
          if (e === "cancel") {
            this.$message({
              type: "info",
              message: "已取消",
            });
          } else {
            this.$message({
              type: "error",
              message: "操作失败",
            });
          }
        });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
.dialog-switch .el-radio {
  display: block;
}

.dialog-switch .el-radio + .el-radio {
  margin: 10px 0 0;
}

.push-records {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/views/standardJob/jobs.vue